import {
  GET_SF_FILTERS,
  GET_SF_FILTERS_SUCCESS,
  GET_SF_FILTERS_ERROR,
  GET_SOURCE_TYPES,
  GET_SOURCE_TYPES_SUCCESS,
  GET_SOURCE_TYPES_ERROR,
  GET_SF_SMART_VIEWS,
  GET_SF_SMART_VIEWS_SUCCESS,
  GET_SF_SMART_VIEWS_ERROR,
  GET_CAMPAIGN_SOURCE_TYPES,
  GET_CAMPAIGN_SOURCE_TYPES_SUCCESS,
  GET_CAMPAIGN_SOURCE_TYPES_ERROR,
  GET_SOURCE_TYPES_BY_ACCOUNT,
  GET_SOURCE_TYPES_BY_ACCOUNT_SUCCESS,
  GET_SOURCE_TYPES_BY_ACCOUNT_ERROR,
  GET_MARKETING_GROUPS,
  GET_MARKETING_GROUPS_SUCCESS,
  GET_MARKETING_GROUPS_ERROR
} from "./actionTypes"

const initialState = {
  error: null,
  sf_filters: [],
  source_types: [],
  sf_smart_views: [],
  campaign_source_types: [],
  source_types_by_account: [],
  source_types_by_account_loading: null,
  source_types_by_account_error: null,
  marketing_groups: [],
  marketing_groups_loading: null,
  marketing_groups_error: null,
}

const SfCommonData = (state = initialState, action) => {
  switch (action.type) {
    case GET_SF_FILTERS:
      return {
        ...state,
      }

    case GET_SF_FILTERS_SUCCESS:
      return {
        ...state,
        sf_filters: action.payload,
      }

    case GET_SF_FILTERS_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SOURCE_TYPES:
      return {
        ...state,
      }

    case GET_SOURCE_TYPES_SUCCESS:
      return {
        ...state,
        source_types: action.payload,
      }

    case GET_SOURCE_TYPES_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SF_SMART_VIEWS:
      return {
        ...state,
      }

    case GET_SF_SMART_VIEWS_SUCCESS:
      return {
        ...state,
        sf_smart_views: action.payload
      }

    case GET_SF_SMART_VIEWS_ERROR:
      return {
        ...state,
        error: action.payload
      }
    case GET_CAMPAIGN_SOURCE_TYPES:
      return {
        ...state,
      }

    case GET_CAMPAIGN_SOURCE_TYPES_SUCCESS:
      return {
        ...state,
        campaign_source_types: action.payload,
      }

    case GET_CAMPAIGN_SOURCE_TYPES_ERROR:
      return {
        ...state,
        error: action.payload,
      }

    case GET_SOURCE_TYPES_BY_ACCOUNT:
      return {
        ...state,
        source_types_by_account_loading: true,
        source_types_by_account_error: null,
      }

    case GET_SOURCE_TYPES_BY_ACCOUNT_SUCCESS:
      return {
        ...state,
        source_types_by_account: action.payload,
        source_types_by_account_loading: false,
        source_types_by_account_error: null,
      }

    case GET_SOURCE_TYPES_BY_ACCOUNT_ERROR:
      return {
        ...state,
        source_types_by_account_loading: false,
        source_types_by_account_error: action.payload,
      }

    case GET_MARKETING_GROUPS:
      return {
        ...state,
        marketing_groups_loading: true,
        marketing_groups_error: null,
      }

    case GET_MARKETING_GROUPS_SUCCESS:
      return {
        ...state,
        marketing_groups: action.payload,
        marketing_groups_loading: false,
        marketing_groups_error: null,
      }

    case GET_MARKETING_GROUPS_ERROR:
      return {
        ...state,
        marketing_groups_loading: false,
        marketing_groups_error: action.payload,
      }

    default:
      return state
  }
}

export default SfCommonData
